import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import leftArrow from '../assets/icon_left_arrow.png'

const ModalFaq = ({confirmIsOpen, iframe, back}) => {
    console.log(iframe)
	return (
		<Modal className="modal-confirmation modal-term" isOpen={confirmIsOpen} backdrop='static' fade={false} >
		<ModalBody>
			<nav className="navbar fixed-top navbar-expand-lg navbar-light bg-light">
				<div className="col-12" style={{padding: '0'}}>
						<div className="row">
							<div className="col-2" style={{paddingLeft: '15px', textAlign: 'start'}}>
								<img src={leftArrow} style={{width: '1.2rem', height: '1.3rem', verticalAlign: 'text-top'}} onClick={() => back()} alt=""/>
							</div>
							<div className="col-8 text-center" style={{fontSize: '1rem', fontWeight: '500'}}>
								FAQ
							</div>
							<div className="col-2"></div>
						</div>
				</div>
			</nav>  
			<div className="term-iframe">
				<div dangerouslySetInnerHTML={{__html:iframe}} />
			</div>
		</ModalBody>
		</Modal>
	);
}

export default ModalFaq
